import { Link } from 'react-router-dom';
import '../../style/pages/error.css';
import LogoWork from '../../components/global/logoWork';

export default function Error () {
    return (
        <div className="error-page flex flex-center-center">
            <div className="error-box">
                <LogoWork/>
                <h2>عميلنا العزيز هذه الصفحة غير موجودة</h2>
                <h3>خطأ رقم 404 <i className="fa-solid fa-bug"></i></h3>
                <div className='roles'>
                    <h4>قواعد و ارشادات</h4>
                    <ul>
                        <li>التلاعب في أعدادات النظام سوف يؤدي على اغلاق الحساب تماما</li>
                        <li>لا يمكن استخدام الحساب اكتر من جهازين فقط</li>
                        <li>اذا مر 6 شهور على اغلاق الحساب سوف يتم حذف الحساب تماما و بدأ الأجرائات مره اخره جديد</li>
                    </ul>
                    <p>اذا لديك مشكلة في الدفع يرجى الرجوع للدعم الفني و تقديم طلب في خلال لحظات يتم الرد على طلبك</p>
                    <p>نحن هنا لكي نساعدك في تطوير عملك و تقديم كل وسائل الراحه لك</p>
                    <p>...شكرا لتفهمكم</p>
                    <Link to={'/pos'}>الرجوع للصفحة الرئيسية</Link>
                </div>
            </div>
        </div>
    )
}